import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Arranqué sin experiencia… hoy tengo pedidos todas las semanas. Es increíble lo simple que es cuando tenés el paso a paso.',
  author: 'María',
  location: 'Buenos Aires'
}, {
  quote: 'Nunca pensé que cocinar podía ser un negocio. En 3 semanas ya tenía clientes fijos en mi barrio.',
  author: 'Laura',
  location: 'Córdoba'
}, {
  quote: 'El plan de 30 días me cambió todo. Simple, directo y sin vueltas. Ya recuperé la inversión 10 veces.',
  author: 'Carolina',
  location: 'Rosario'
}];
export function SocialProof() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal relative" data-id="element-145">
      <div className="max-w-6xl mx-auto" data-id="element-146">
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-147">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-charcoal-light border border-white/5 p-8 rounded-2xl relative" data-id="element-148">
              <div className="flex gap-1 mb-6" data-id="element-149">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-150" />)}
              </div>

              <p className="text-lg font-serif text-cream-muted italic mb-8 leading-relaxed" data-id="element-151">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-152">
                <div className="w-10 h-10 rounded-full bg-warmBrown flex items-center justify-center border border-gold/20 text-gold font-serif font-bold" data-id="element-153">
                  {testimonial.author[0]}
                </div>
                <div data-id="element-154">
                  <div className="font-medium text-cream" data-id="element-155">
                    {testimonial.author}
                  </div>
                  <div className="text-xs text-cream-muted/60" data-id="element-156">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}